module.exports = __webpack_public_path__ + "img/tijana-denkovska.67fc8603.jpg";